import ImageSB from '@/components/atoms/image/ImageSB';
import { LinkButtonSBProps } from '@/components/atoms/linkButton/LinkSB';
import RichTextFieldSB from '@/components/atoms/richTextField/RichTextFieldSB';
import { Text } from '@/components/atoms/text';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { BannerStrapiProps } from '@/components/molecules/banner/BannerStrapi';

import { BlockWrapper } from '@/features/utils/BlockWrapper';

import SideBanner, {
  SideBannerProps,
} from '@/components/molecules/banner/SideBanner';

export interface SideBannerStrapiProps {
  outerTitle: string;
  banner: BannerStrapiProps;
}

function getBannerButtons(
  buttons: LinkButtonSBProps[]
): SideBannerProps['items'] {
  const paths = buttons?.map((item) => ({
    href: item.url,
    label: item.text,
  }));

  return paths;
}

export function SideBannerStrapi({
  block,
}: BlockComponentModel<SideBannerStrapiProps>) {
  const { banner, outerTitle } = block;
  const { image, title, description, buttons } = banner;
  const transformedButtons = getBannerButtons(buttons) || [];

  return (
    <BlockWrapper classNames={{ root: 'bg-transparent dark:bg-transparent' }}>
      <div data-tracker-section='side-banner'>
        {outerTitle && (
          <div className='mb-6'>
            <Text variant='label-text-l' color='neutral-N50'>
              {outerTitle}
            </Text>
          </div>
        )}
        <SideBanner
          items={transformedButtons}
          description={
            description ? <RichTextFieldSB block={description} /> : null
          }
          title={title}
          image={
            image ? (
              <ImageSB
                inner={{ classNames: { image: 'w-9' } }}
                block={{ ...image }}
              />
            ) : null
          }
        />
      </div>
    </BlockWrapper>
  );
}
